import { Children, cloneElement, FC, ReactElement, ReactNode } from 'react';
import { cn } from '@fe-learner-common';

interface SkeletonProps {
  className?: string;
  type?: keyof typeof types;
}

export const PaginationSkeleton = () => {
  return (
    <div className="flex w-full justify-between pt-3">
      <Skeleton type="button" className="h-[32px]" />

      <div className="flex items-center gap-x-2">
        <Skeleton className="h-[32px] w-[32px] rounded-lg" />
        <Skeleton className="h-[32px] w-[32px] rounded-lg" />
        <Skeleton className="h-[32px] w-[32px] rounded-lg" />
      </div>

      <Skeleton type="button" className="h-[32px]" />
    </div>
  );
};

export const ListSkeleton = ({ noItems }: { noItems: number }) => {
  return (
    <div className="flex flex-col gap-2">
      {[...Array(noItems || 8)].map((_, index) => (
        <Skeleton className="h-[84px] rounded-xl" key={index} type="row" />
      ))}
      <div className="flex justify-between">
        <Skeleton className="h-8 " type="button" />
        <Skeleton className="h-8 " type="button" />
      </div>
    </div>
  );
};

const types = {
  title: 'w-[240px] h-6 rounded-xl',
  text: 'w-[76px] h-2 rounded-xl',
  card: 'aspect-video rounded-xl',
  button: 'w-[76px] h-10 rounded-lg',
  iconButton: 'h-10 w-10 rounded-lg',
  row: 'w-full h-12',
};
export const Skeleton: FC<SkeletonProps> = ({ className, type }) => {
  return (
    <div
      className={cn(
        'animate-pulse bg-neutral-500',
        type && types[type],
        className,
      )}
    />
  );
};

interface SkeletonWrapperProps extends SkeletonProps {
  isLoading: boolean;
  skeletonClassName?: string;
  customSkeleton?: ReactNode;
  children: ReactNode;
}

export const SkeletonWrapper: FC<SkeletonWrapperProps> = ({
  children,
  isLoading,
  skeletonClassName,
  customSkeleton,
  ...rest
}) => {
  return isLoading
    ? customSkeleton || (
        <Skeleton
          {...rest}
          className={cn(rest?.className, skeletonClassName)}
        />
      )
    : Children.map(children, (child: ReactElement) => {
        return (
          child &&
          cloneElement(child, {
            ...rest,
            className: cn(rest?.className, child?.props?.className),
          })
        );
      });
};
